import { render, staticRenderFns } from "./FilingsView.vue?vue&type=template&id=0abae034&scoped=true&"
import script from "./FilingsView.vue?vue&type=script&lang=ts&"
export * from "./FilingsView.vue?vue&type=script&lang=ts&"
import style0 from "./FilingsView.vue?vue&type=style&index=0&id=0abae034&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abae034",
  null
  
)

export default component.exports